<template>
  <div class="container-fluid p-0"> <!-- حاوية مرنة -->
    <div class="card shadow-sm border-top-primary">
      
      <!-- رأس الكارت -->
      <div class="card-header bg-white py-3">
        <h5 class="fw-bold mb-0 text-primary">
          <i class="fas fa-paper-plane ms-2"></i> إرسال تعليمات للجان
        </h5>
      </div>

      <div class="card-body p-4">
        <form @submit.prevent="sendInstruction">
          
          <!-- 1. عنوان التنبيه -->
          <div class="mb-3">
            <label class="form-label fw-bold text-dark small">عنوان التنبيه</label>
            <div class="input-group">
              <span class="input-group-text bg-light"><i class="fas fa-heading text-secondary"></i></span>
              <input 
                v-model="form.title" 
                type="text" 
                class="form-control" 
                required 
                placeholder="مثال: تنبيه هام بخصوص مواعيد الانصراف..."
              >
            </div>
          </div>
          
          <!-- 2. نص التعليمات -->
          <div class="mb-3">
            <label class="form-label fw-bold text-dark small">نص التعليمات</label>
            <textarea 
              v-model="form.content" 
              class="form-control" 
              rows="5" 
              required
              placeholder="اكتب تفاصيل التعليمات هنا..."
            ></textarea>
          </div>

          <!-- 3. الصف المتجاوب (درجة الأهمية + التوجيه) -->
          <div class="row g-3 mb-3">
            
            <!-- درجة الأهمية -->
            <div class="col-12 col-md-6">
              <label class="form-label fw-bold text-dark small">درجة الأهمية</label>
              <select v-model="form.type" class="form-select">
                <option value="normal">🔵 عادي (للعلم)</option>
                <option value="urgent">🔴 هام وعاجل (للتحذير)</option>
              </select>
            </div>

            <!-- التوجيه -->
            <div class="col-12 col-md-6">
              <label class="form-label fw-bold text-dark small">توجيه الرسالة إلى:</label>
              <select v-model="form.target_type" class="form-select">
                <option value="all">📢 جميع اللجان (تعميم)</option>
                <option value="specific">🎯 لجنة محددة فقط</option>
              </select>
            </div>
          </div>

          <!-- 4. اختيار اللجنة (يظهر شرطياً) -->
          <transition name="fade">
            <div v-if="form.target_type === 'specific'" class="mb-4 p-3 bg-light border border-primary rounded-3">
              <label class="form-label fw-bold text-primary small">
                <i class="fas fa-filter ms-1"></i> اختر اللجنة المستهدفة:
              </label>
              <select v-model="form.target_committee_number" class="form-select">
                 <option value="">-- ابحث واختر اللجنة --</option>
                 <option v-for="c in committees" :key="c.id" :value="c.id">
                   لجنة رقم {{ c.id }} - {{ c.commitee_name}}
                 </option>
              </select>
            </div>
          </transition>

          <!-- 5. زر الإرسال -->
          <div class="d-grid gap-2">
            <button type="submit" class="btn btn-primary btn-lg shadow-sm" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              <span v-else><i class="fas fa-paper-plane ms-2"></i> إرسال التعليمات الآن</span>
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "AdminSendInstruction",
  data() {
    return {
      loading: false, // حالة التحميل
      committees: [],
      form: {
        title: '',
        content: '',
        type: 'normal',
        target_type: 'all',
        target_committee_number: ''
      }
    };
  },
  mounted() {
    this.fetchCommittees();
  },
  methods: {
    async fetchCommittees() {
      try {
        const res = await api.get('/admin/getCommittee');
        this.committees = res.data;
      } catch (error) {
        console.error("Error fetching committees", error);
      }
    },

    async sendInstruction() {
      if (this.form.target_type === 'specific' && !this.form.target_committee_number) {
          alert("عفواً، يرجى اختيار اللجنة المستهدفة من القائمة");
          return;
      }

      this.loading = true; // تفعيل التحميل

      try {
        await api.post('/admin/instructions', this.form);
        
        // رسالة نجاح وتصفير النموذج
        alert("تم تعميم التعليمات بنجاح");
        this.resetForm();

      } catch (e) {
        alert("حدث خطأ أثناء الإرسال، يرجى المحاولة مرة أخرى");
        console.error(e);
      } finally {
        this.loading = false; // إيقاف التحميل
      }
    },

    resetForm() {
      this.form.title = '';
      this.form.content = '';
      this.form.type = 'normal';
      this.form.target_type = 'all';
      this.form.target_committee_number = '';
    }
  }
};
</script>

<style scoped>
.border-top-primary {
  border-top: 4px solid #0d6efd;
}

/* تأثير ظهور ناعم لحقل اختيار اللجنة */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* تحسينات للشاشات الصغيرة */
@media (max-width: 576px) {
  .card-body {
    padding: 1rem !important;
  }
}
</style>